import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import "./_style.scss";

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLR410001_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: "退職者識別コード",
    keyword: "retirementMoneyRequestCd",
    requiredIcon: true,
    inputProps: { minLength: 9, maxLength: 9 },
  },
  {
    title: "退職者名",
    keyword: "name",
    type: "name",
    requiredIcon: true,
  },
  {
    title: "退職者名(フリガナ)",
    keyword: "nameKana",
    type: "name",
    requiredIcon: true,
    useFurigana: true,
    convertToHalfwidth: true,
    hafWidth: true,
  },
  {
    title: "生年月日",
    keyword: "birthday",
    type: "date",
    requiredIcon: true,
    maxDate: new Date(),
    minDate: new Date("1900/1/1"),
  },
  {
    title: "メールアドレス(機構連絡用)",
    keyword: "email",
    type: "mail",
    requiredIcon: true,
    inputProps: { minLength: 1, maxLength: 255 },
  },
  {
    keyword: "title2",
    type: "lineTitle",
    lineTitle: (
      <>
        入力されたメールアドレス宛に「退職手当金請求書」のＵＲＬリンクを送信しますので、【＠wam.go.jp】ドメインからのメールが届くように設定をお願いします。
        <br />
        ※登録後、
        <span className="tkUnderLine">１時間以内にメールが届かない場合</span>
        <TkHelpIcon
          helpMessage={
            <>
              携帯電話、スマートフォンにメールが届かない場合は、受信拒否設定されている場合が考えられます。【＠wam.go.jp】ドメインからのメールが届くように設定をお願いします。
              <br />
              パソコンにメールが届かない場合は、迷惑メールに配信されている場合が考えられます。
              <br />
              迷惑メールフォルダを確認してください。
            </>
          }
        />
        は、登録したメールアドレスの入力に誤りがある事が考えられますので、
        <span className="tkUnderLine">再度登録</span>
        を行ってください。
      </>
    ),
  },
  {
    title: "メールアドレス(機構連絡用) (確認用)",
    keyword: "emailConfirm",
    type: "mail",
    requiredIcon: true,
    inputProps: { minLength: 1, maxLength: 255 },
  },
];
const schema = {
  retirementMoneyRequestCd: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    minLength: {
      value: 6,
      message: "6桁で入力してください",
    },
    maxLength: {
      value: 6,
      message: "6桁で入力してください",
    },
    pattern: {
      value: /^[a-zA-Z0-9]+$/,
      message: "半角英数字で入力してください",
    },
  },
  name: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
  },
  nameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
  },
  birthday: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxDate: {
      value: new Date("2099/12/31"),
      message: TkPropertyMessageGet("TKMSG_SCR0051E", "2099/12/31"),
    },
    minDate: {
      value: new Date("1900/1/1"),
      message: TkPropertyMessageGet("TKMSG_SCR0050E", "1900/1/1"),
    },
  },
  email: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
  },
  emailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
  },
};

export { fakeTableList, schema };
